module.exports = __webpack_public_path__ + "img/keder_weiss_candy.bc5dedbc.jpg";